module.exports = __webpack_public_path__ + "src/img/shareIcon.60f4a10c.png";